import React, { useContext, useState } from 'react'
import Icons from '../../components/Icons'
import { Context } from "../contexts/AppContext";
import Layout from './LayoutGallery'; 

function CreateNewGallery(props) {
       const { value } = useContext(Context);
      const [appState, setAppState] = value;
       
    
      const openLayoutPage=()=>{
        props.closeCreateNewGalleryPage();       
      }
  return (        
    <button className="bg-yellow-800 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded flex gap-2  "  onClick={openLayoutPage}>
    + New Gallery<Icons.Uploads />
    </button>  
  )
}

export default CreateNewGallery